(function () {
  function formatMoney(cents, symbol) {
    var amount = (cents / 100).toFixed(2);
    if (amount.endsWith('.00')) amount = amount.slice(0, -3);
    return symbol + amount;
  }

  function initSection(root) {
    if (!root || root.dataset.motpInit === 'true') return;
    root.dataset.motpInit = 'true';

    var form = root.querySelector('.motp__form');
    var checkbox = root.querySelector('.motp__checkbox');
    var sellingPlanInput = root.querySelector('.motp__selling-plan-input');
    var cta = root.querySelectorAll('.motp__cta');
    // var ctaPrice = root.querySelector('[data-cta-price]');
    var ctaPrice=root.querySelectorAll('[data-cta-price]');
    var priceDisplay = root.querySelector('[data-price-display]');
    var todayPrice = root.querySelector('.motp__today-price');
    var unlockedHead = root.querySelector('[data-unlocked-head]');
    var lockedHead = root.querySelector('[data-locked-head]');
    var unlockedFoot = root.querySelector('[data-unlocked-foot]');
    var lockedFoot = root.querySelector('[data-locked-foot]');
    var compareEl = root.querySelector('.motp__compare');
    var savePill = root.querySelector('.motp__save-pill');
    var perDose = root.querySelector('[data-per-dose]');
    var errorEl = root.querySelector('.motp__error');
    var mainMedia = root.querySelector('[data-motp-main-media]');
    var thumbs = root.querySelectorAll('[data-motp-thumb]');
    var templates = root.querySelectorAll('[data-motp-template]');

    var onetimeCents = parseInt(root.dataset.onetimePrice, 10);
    var subCents = parseInt(root.dataset.subPrice, 10) || onetimeCents;
    var compareCents = parseInt(root.dataset.comparePrice, 10) || onetimeCents;
    var doses = parseInt(root.dataset.doses, 10) || 30;
    var symbol = root.dataset.currency || '$';
    var sellingPlanId = root.dataset.sellingPlanId || '';

    function isSub() {
      return checkbox && checkbox.checked;
    }

    function activeCents() {
      return isSub() ? subCents : onetimeCents;
    }

    function updateUI() {
      var sub = isSub();
      root.classList.toggle('is-subscription', sub);

      var formatted = formatMoney(activeCents(), symbol);

      if (priceDisplay) priceDisplay.textContent = formatted;
      // if (ctaPrice) ctaPrice.textContent = formatted;
       ctaPrice.forEach(function(el) {
       el.textContent = formatted;
       });

      if (todayPrice) {
        todayPrice.classList.toggle('is-sub', sub);
        todayPrice.classList.toggle('is-onetime', !sub);
      }

      if (unlockedHead) unlockedHead.hidden = !sub;
      if (lockedHead) lockedHead.hidden = sub;
      if (unlockedFoot) unlockedFoot.hidden = !sub;
      if (lockedFoot) lockedFoot.hidden = sub;

      if (perDose) {
        perDose.textContent = symbol + (activeCents() / 100 / doses).toFixed(2) + ' per dose';
      }

      if (compareEl && savePill) {
        if (sub && compareCents > subCents) {
          compareEl.textContent = formatMoney(compareCents, symbol);
          compareEl.hidden = false;
          var save = compareCents - subCents;
          savePill.textContent = 'SAVE ' + formatMoney(save, symbol);
          savePill.hidden = false;
        } else {
          compareEl.hidden = true;
          savePill.hidden = true;
        }
      }

      if (sellingPlanInput) {
        if (sub && sellingPlanId) {
          sellingPlanInput.value = sellingPlanId;
          sellingPlanInput.removeAttribute('disabled');
        } else {
          sellingPlanInput.value = '';
          sellingPlanInput.setAttribute('disabled', 'disabled');
        }
      }
    }

    if (checkbox) {
      checkbox.addEventListener('change', updateUI);
    }

    if (thumbs.length && mainMedia && templates.length) {
      thumbs.forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          var index = thumb.getAttribute('data-media-index');
          var template = root.querySelector('[data-motp-template="' + index + '"]');
          if (!template) return;

          var video = mainMedia.querySelector('video');
          if (video) {
            video.pause();
          }

          mainMedia.innerHTML = template.innerHTML;

          thumbs.forEach(function (t) {
            var active = t === thumb;
            t.classList.toggle('is-active', active);
            t.setAttribute('aria-current', active ? 'true' : 'false');
          });
        });
      });
    }

    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        if (!cta) return;

        // cta.disabled = true;
        // cta.classList.add('is-loading');

        if (!cta.length) return;

cta.forEach(function(btn) {
  btn.disabled = true;
  btn.classList.add('is-loading');
});

        if (errorEl) errorEl.classList.remove('is-visible');

        var formData = new FormData(form);

        fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart/add.js' : '/cart/add.js', {
          method: 'POST',
          body: formData,
          headers: { Accept: 'application/json' }
        })
          .then(function (res) {
            if (!res.ok) return res.json().then(function (err) { throw err; });
            return res.json();
          })
          .then(function () {
            var rootUrl = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
            return fetch(rootUrl + '?section_id=cart-drawer');
          })
          .then(function (res) { return res.text(); })


          .then(function (html) {
            var parser = new DOMParser();
            var doc = parser.parseFromString(html, 'text/html');
            var newDrawer = doc.querySelector('cart-drawer');
            var currentDrawer = document.querySelector('cart-drawer');

            if (newDrawer && currentDrawer) {
              currentDrawer.replaceWith(newDrawer.cloneNode(true));
            }

            requestAnimationFrame(function () {
              var drawer = document.querySelector('cart-drawer');
              if (drawer && typeof drawer.open === 'function') {
                drawer.open();
              } else if (drawer) {
                drawer.classList.add('active');
                document.body.classList.add('overflow-hidden');
              } else {
                window.location.href = (window.Shopify && window.Shopify.routes
                  ? window.Shopify.routes.root : '/') + 'cart';
              }
            });
          })

          .catch(function (err) {
            if (errorEl) {
              errorEl.textContent = err.description || err.message || 'Could not add to cart. Please try again.';
              errorEl.classList.add('is-visible');
            }
          })
          .finally(function () {
            // cta.disabled = false;
            // cta.classList.remove('is-loading');
            cta.forEach(function(btn) {
  btn.disabled = false;
  btn.classList.remove('is-loading');
});
          });
      });
    }

    var defaultSub = root.dataset.defaultPurchase === 'subscription';
    if (checkbox) checkbox.checked = defaultSub;
    updateUI();
  }

  function boot() {
    document.querySelectorAll('.motp[data-section-id]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target.querySelector('.motp[data-section-id]');
    if (section) initSection(section);
  });
})();
